// extracted by mini-css-extract-plugin
export default {"section":"foodwaste_section__-tG6g","article":"foodwaste_article__CESrC","content":"foodwaste_content__tlspY","imgbox":"foodwaste_imgbox__+ABv9"};